module.exports = __webpack_public_path__ + "img/withdrawType_fingerIcon.2d989202.png";